import React from 'react';
import {
    BodyLargeRegular,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H3Emphasized,
    Icon,
    Sheet,
    SplitIcon,
    View,
    YStack,
} from 'smoothie';

interface IncomeSplitWelcomeSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

export const IncomeSplitWelcomeSheet = ({
    isOpen,
    onClose,
}: IncomeSplitWelcomeSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            forceKeyboardCompatibleBottomSheet={true}
        >
            <YStack>
                <View
                    alignSelf="center"
                    justifyContent="center"
                    alignItems="center"
                    width={80}
                    height={80}
                    padding={20}
                    marginVertical={16}
                    rotate="180deg"
                    borderRadius={16}
                    backgroundColor="$gray100"
                >
                    <Icon icon={SplitIcon} color="$black" size={32} />
                </View>

                <YStack alignItems="center" gap={8}>
                    <H3Emphasized>Welcome to Income Split</H3Emphasized>
                    <BodyMediumRegular color="$gray1000">
                        When a deposit arrives, your Income Split rules will
                        direct it across accounts based on your priorities.
                    </BodyMediumRegular>
                </YStack>

                <YStack gap={16} marginTop={32}>
                    <YStack gap={8}>
                        <BodyLargeRegular>How it works</BodyLargeRegular>
                        <BodyMediumRegular color="$gray1000">
                            By default, your rules will be applied to all income
                            arriving into the specified Fruitful bank accounts.
                            You can modify this in the Income section.
                        </BodyMediumRegular>
                    </YStack>

                    <YStack gap={8}>
                        <BodyLargeRegular>
                            What&apos;s classified as income?
                        </BodyLargeRegular>
                        <BodyMediumRegular color="$gray1000">
                            Income is defined as any deposits made into these
                            accounts, such as paychecks, interest earned, or
                            cash back. Excludes ACH returns and reversals,
                            provisional credits, and transfers initiated from
                            Fruitful.
                        </BodyMediumRegular>
                    </YStack>
                </YStack>

                <View marginTop={32} width="100%">
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Got it"
                        onPress={onClose}
                    />
                </View>
            </YStack>
        </Sheet>
    );
};
export default IncomeSplitWelcomeSheet;
